<script>
import mapValues from 'lodash/mapValues'

import levels from '@/levels'

import Settings from '../game/Settings'

export default {

  components: {
    Settings
  },

  data () {
    return {
      settingsVisible: false
    }
  },

  computed: {

    mapLinks () {
      return mapValues(levels, ({ name }, id) => {
        return {
          id,
          name
        }
      })
    }

  },

  methods: {

    levelIsCompleted (levelId) {
      return this.$store.getters.levelIsCompleted(levelId)
    },

    toggleSettings () {
      this.settingsVisible = !this.settingsVisible
    }

  }

}
</script>

<template>
  <div
    :class="{
      'c-view-main-menu-on-settings': settingsVisible,
      'c-view-main-menu-on-main': !settingsVisible
    }"
    class="c-view-main-menu"
  >

    <div class="c-view-main-menu-content">

      <img
        src="/bitmaps/game-logo.png"
        alt="Full Spectrum Warrior Go"
        title="Full Spectrum Warrior Go"
        class="c-view-main-menu-logo"
      >

      <settings
        v-if="settingsVisible"
        class="c-view-main-menu-settings"
        @back="toggleSettings"
      />

      <div
        v-else
        class="c-view-main-menu-items"
      >

        <router-link
          v-if="$store.getters.completedLevelIds && ($store.getters.currentLevelId || $store.getters.nextLevelId)"
          :to="{
            name: 'level',
            params: {
              levelId: $store.getters.currentLevelId || $store.getters.nextLevelId
            }
          }"
          class="c-view-main-menu-item"
        >
          Continue campaign
        </router-link>

        <router-link
          v-for="({ name, id }) in mapLinks"
          :key="id"
          :to="{
            name: 'level',
            params: {
              levelId: id
            }
          }"
          class="c-view-main-menu-item"
        >
          <strong>
            <template v-if="levelIsCompleted(id)">
              ✅
            </template>
            {{ name }}
          </strong>
        </router-link>

        <button
          class="c-view-main-menu-item"
          @click="toggleSettings"
        >
          Settings
        </button>

        <router-link
          :to="{
            name: 'debug'
          }"
          class="c-view-main-menu-item"
        >
          Debug
        </router-link>

      </div>

    </div>

    <img
      src="/bitmaps/splash-screen.jpg"
      class="c-view-main-menu-image"
    >
  </div>
</template>

<style lang="scss">

.c-view-main-menu {
  position: relative;
  width: 100%;
  height: 100%;
}

.c-view-main-menu-logo {
  height: 4em;
  margin-bottom: 1em;
}

.c-view-main-menu-image {
  @include fill;
  @include cover;
  z-index: 1;

  @include transition-properties-common;
  @include transition-very-slow;
}

.c-view-main-menu-on-settings {
  .c-view-main-menu-image {
    opacity: 0.5;
  }
}

.c-view-main-menu-content {
  @include keep-full-center;
  @include border-box;
  @include scroll-vertical;
  @include radius;
  @include shadow-loose;
  z-index: 2;
  background-color: translucent($black, 0.95);
  padding: 2em 2em 3em 2em;
  width: 22em;
  max-height: 100%;
  text-align: center;
  backdrop-filter: blur(10px);
}

// .c-view-main-menu-items {}

.c-view-main-menu-item {
  @include block;
  @include keep-center;
  @include push-pad-bottom;

  @include pad-tight;
  @include radius-tight;
  @include uppercase;
  color: #D9D121;
  background-color: translucent(#575400, 0.4);

  &:hover {
    background-color: translucent(#575400, 0.6);
  }

}

</style>
